import axios from 'axios';
import { getAuthToken } from '../auth-token';
import { addToFailedQueue, clearAuthData } from '../auth-event';

const baseURL =
  process.env.NEXT_PUBLIC_N8N_BASE_URL || 'https://n8n.clickster.io/webhook';

export const N8N = axios.create({
  baseURL,
});

N8N.interceptors.request.use((config) => {
  const token = getAuthToken();
  if (token) {
    config.headers.Authorization = `Bearer ${token}`;
  }
  return config;
});

/**
 * Middleware to handle invalid or expired tokens
 * Shows auth modal when 401 Unauthorized is detected
 * Queues failed requests for retry after login
 */
N8N.interceptors.response.use(
  (response) => response,
  (error) => {
    const originalRequest = error.config;

    // Only handle 401 errors that haven't been retried yet
    if (error.response && error.response.status === 401 && !originalRequest._retry) {
      originalRequest._retry = true;

      // Clear auth data from storage
      clearAuthData();

      // Queue the failed request and show auth modal
      return addToFailedQueue(originalRequest);
    }

    return Promise.reject(error);
  },
);
